import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  Grid,
  Button,
  TextField
} from '@material-ui/core';
import axios from 'axios';
import { API_LOCAL } from '../../../../constants'; 
const useStyles = makeStyles(() => ({
  root: {}
}));

const AccountDetails = props => {
  const { user, updateUser, apiManager, className, ...rest } = props;

  const firstName = user['custom:firstName'];
  const lastName = user['custom:lastName'];
  const isSubscribed = user['custom:isSubscribed'];
  const subExpires = user['custom:subExp'];
  const subId = user['sub'];
  const email = user['email'];
  const data = props;

  const classes = useStyles();

  const [values, setValues] = useState({
    firstname: user['custom:firstName'],
    lastname: user['custom:lastName'],
    isSubscribed: user['custom:isSubscribed'],
    subExpires: user['custom:subExp'],
    subId: user['sub'],
    email: user['email'],
  });
  const [error, setError] = useState();

  const handleChange = event => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };
   
  const updateDetails = async() => {
 
    try {
      const result = await apiManager.updateAccountDetails(values);
      if(result && result.data && result.data._id){
        setError("Profile details have been updated!")
       
        updateUser(result.data);
      }
      else {
        setError("Something went wrong...")
      }
    }
    catch(ex){
      console.log(ex);
    }
  }

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <form
        autoComplete="off"
        noValidate
      >
        <CardHeader
          subheader="Edit your profile information"
          title="Profile"
        />
        <Divider />
        <CardContent>
          <Grid
            container
            spacing={3}
          >
             <Grid
              item
              md={12}
              xs={12}
            >
       {error }
      </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                helperText="Please specify the first name"
                label="First name"
                margin="dense"
                name="firstname"
                onChange={handleChange}
                required
                value={values.firstname}
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                label="Last name"
                margin="dense"
                name="lastname"
                onChange={handleChange}
                required
                value={values.lastname}
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                label="Email Address"
                margin="dense"
                name="email"
                onChange={handleChange}
                required
                value={values.email}
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
                {/* <TextField
                fullWidth
                label="Phone"
                margin="dense"
                name="phone"
                onChange={handleChange}
                required
                value={values.phone}
                variant="outlined"
              /> */}
            </Grid>
            <Grid
              item
              md={12}
              xs={12}
            >
               
            </Grid>
             
          </Grid>
        </CardContent>
        <Divider />
        <CardActions>
          <Button
            color="primary"
            variant="outlined"
            onClick={updateDetails}
          >
            Update
          </Button>
        </CardActions>
      </form>
    </Card>
  );
};

AccountDetails.propTypes = {
  className: PropTypes.string,
  updateUser: PropTypes.func
};

export default AccountDetails;
